module.exports = __webpack_public_path__ + "static/img/sdasd.975446e5.jpg";